export const ACTION = {
    ADD: 'ADD',
    REMOVE: 'REMOVE',
    MOVE: 'MOVE'
}
